import nextId from "react-id-generator"

export const links = [
    {
        id: nextId(),
        url: "#banner",
        text: "home"
    },
    {
        id: nextId(),
        url: "#featured",
        text: "featured"
    },
    {
        id: nextId(),
        url: "#products",
        text: "products"
    },
    {
        id: nextId(),
        url: "#news",
        text: "news"
    },
    // {
    //     id: nextId(),
    //     url: "#shop",
    //     text: "shop"
    // },
]